// import Vue from 'vue'
// import { 
//   reqOrderList,
//   } from "../../api"
import {
  AMEND_GOODSDATA
  } from '../type'

  export default{
    state:{
      goodsKey:{},//展品搜索关键字
      
    },
    mutations:{
      
      [AMEND_GOODSDATA](state,data){
        state.shopOrder= data
      }
    },
    actions:{
      //shops
      //获取商品信息
      goodsData({commit},choose,product){
          commit(AMEND_GOODSDATA,{choose,product})
      }
    },
    getters:{
      //总数量
      // totalCount (state) {
      //   return state.cartFoods.reduce((pre, food) => pre + food.num, 0)
      // }
    }
  }